export const basketSubmittedGroupTitleLocale = $localize`:CBasket|Submitted products group name@@submittedProductsGroupName:Submitted`;
